<ng-container *ngIf="isAdmin; else elseBlock">
    <app-admin-contents-list></app-admin-contents-list>
</ng-container>
<ng-template #elseBlock>
    <app-contents-list></app-contents-list>
</ng-template>